import { render, staticRenderFns } from "./Carousel-Team.vue?vue&type=template&id=5c98606e"
import script from "./Carousel-Team.vue?vue&type=script&lang=js"
export * from "./Carousel-Team.vue?vue&type=script&lang=js"
import style0 from "./Carousel-Team.vue?vue&type=style&index=0&id=5c98606e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports